import { Flex, Skeleton } from '@chakra-ui/react';
import { contentSx } from './styles';

export const LoadingState = () => (
  <Flex sx={contentSx}>
    {[...Array(8)].map((_, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <Skeleton key={index} flexShrink={0} width="144px" h="192px" mr={6} />
    ))}
  </Flex>
);
